<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-150"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div
        v-if="visible"
        class="fixed inset-0 z-[60] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-black/40 backdrop-blur-sm" />
        <transition
          enter-active-class="transition-all duration-200"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100">
          <div
            v-if="visible"
            class="relative bg-surface rounded-xl shadow-flyout w-full max-w-sm p-6 flex flex-col gap-4 items-center text-center">
            <!-- Icono -->
            <div
              v-if="icon !== 'none'"
              :class="['w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0', iconBg]">
              <AlertTriangle
                v-if="icon === 'warning'"
                class="w-5 h-5 text-warn" />
              <XCircle
                v-else-if="icon === 'error'"
                class="w-5 h-5 text-danger" />
              <CheckCircle2
                v-else-if="icon === 'success'"
                class="w-5 h-5 text-success" />
              <Info
                v-else
                class="w-5 h-5 text-info" />
            </div>

            <!-- Texto -->
            <div>
              <h3
                v-if="title"
                class="text-base font-semibold text-ink mb-1">
                {{ title }}
              </h3>
              <p
                v-if="text"
                class="text-sm text-muted">
                {{ text }}
              </p>
            </div>

            <!-- Acciones -->
            <div class="flex gap-3 w-full mt-1">
              <div
                v-if="showCancel"
                class="flex-1">
                <AppButton
                  class="w-full"
                  variant="secondary"
                  @click="resolve(false)">
                  {{ cancelText }}
                </AppButton>
              </div>
              <div class="flex-1">
                <AppButton
                  class="w-full"
                  :variant="confirmBtnVariant"
                  @click="resolve(true)">
                  {{ confirmText }}
                </AppButton>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { AlertTriangle, XCircle, CheckCircle2, Info } from '@lucide/vue'
import AppButton from './AppButton.vue'

const ICON_BG = {
  warning: 'bg-warnSoft',
  error: 'bg-dangerSoft',
  success: 'bg-successSoft',
  info: 'bg-infoSoft',
}

export default {
  name: 'AppConfirmDialog',
  components: { AlertTriangle, XCircle, CheckCircle2, Info, AppButton },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    icon: { type: String, default: 'warning' },
    showCancel: { type: Boolean, default: true },
    confirmText: { type: String, default: 'Confirmar' },
    cancelText: { type: String, default: 'Cancelar' },
  },
  emits: ['resolve'],
  computed: {
    iconBg() {
      return ICON_BG[this.icon] ?? ICON_BG.info
    },
    confirmBtnVariant() {
      const map = {
        warning: 'warning',
        error: 'danger',
        success: 'success',
        info: 'primary',
      }
      return map[this.icon] ?? 'primary'
    },
  },
  methods: {
    resolve(value) {
      this.$emit('resolve', value)
    },
  },
}
</script>
